import CustomEntityParams from "./params-proto"
import ModelProxy from "../../model-proxy"
import ErrorProto from "../../../gd/validation/error"
import EmbedUtils from "../../../gd/utils/embed"
import ErrorFieldCustom from "../../../gd/validation/error-field-custom"

const debug = false
// const debug = "CustomEntity_ParamsDBNoToken"

export default class CustomEntity_ParamsDBNoToken extends CustomEntityParams {

    public apiUpdateUrl         : string
    public apiDeleteUrl         : string

    constructor(data:any, useProxy = true) {
        super(data)

        this.apiUpdateUrl = data?.apiUpdateUrl || ''
        this.apiDeleteUrl = data?.apiDeleteUrl || ''

        return useProxy ? new Proxy(this, ModelProxy) : this
    }

    validate():ErrorProto[] | null  {
        const errors : any[] = []

        if (!this.apiUpdateUrl || !EmbedUtils.isLink(this.apiUpdateUrl)) {
            errors.push(new ErrorFieldCustom(gd.fields.externalEntity.apiUpdateUrl, {message: 'Value should be a valid URL'}))
        }
        if (!this.apiDeleteUrl || !EmbedUtils.isLink(this.apiDeleteUrl)) {
            errors.push(new ErrorFieldCustom(gd.fields.externalEntity.apiDeleteUrl, {message: 'Value should be a valid URL'}))
        }

        debug && console.log(debug, 'validate', errors)

        if (_.isEmpty(errors)) return null
        else return errors
    }

    toJSON():JSONObject {
        const json : JSONObject = super.toJSON()

        json.apiUpdateUrl = this.apiUpdateUrl
        json.apiDeleteUrl = this.apiDeleteUrl

        return json
    }
}